import React from 'react';
import Navbar from './Navbar';
import MysticalParticles from './MysticalParticles';

const Home = () => {
  return (
    <div className="min-h-screen flex flex-col relative">
      {/* Magical Background */}
      <div className="fixed inset-0 -z-10">
        <img 
          src="https://cdn.4fingerstudios.com/Mystveil/Mystveil_map.png" 
          alt="Mystveil Township Map" 
          className="w-full h-full object-cover opacity-30 blur-sm" 
        />
        <div className="absolute inset-0 bg-gradient-to-br from-purple-900/20 via-pink-900/20 to-purple-900/20"></div>
      </div>

      {/* Magical Particles */}
      <MysticalParticles />

      {/* Navigation */}
      <Navbar />

      {/* Hero Section */}
      <main className="flex-grow flex items-center justify-center px-4 py-8">
        <div className="text-center max-w-4xl mx-auto">
          {/* Welcome Logo */}
          <div className="mb-8">
            <img 
              src="https://cdn.4fingerstudios.com/Mystveil/Welcome_to_Mystveil_logo.png" 
              alt="Welcome to Mystveil Township" 
              className="max-w-full h-auto mx-auto"
              style={{
                maxWidth: '600px'
              }}
            />
          </div>

          {/* Welcome Message */}
          <div className="mystical-card max-w-2xl mx-auto">
            <h1 className="mystical-title mb-6">
              Welcome to Mystveil Township
            </h1>
            <p className="mystical-text text-lg mb-6">
              Step into a world where dragons roam the floating islands of The Shifting Lands. 
              Mystveil Township is your gateway to an extraordinary ARPG experience filled with 
              magic, mystery, and endless adventures.
            </p>
            <p className="mystical-text mb-8">
              Begin your journey as a Veilkin hatchling and watch as your character evolves 
              through magical upgrades and experiences. The mystical realm awaits your arrival!
            </p>
            
            {/* Call to Action Buttons */}
            <div className="flex flex-wrap justify-center gap-4">
              <a href="/guide" className="mystical-button">
                Start Your Journey
              </a>
              <a href="/guide/MYO" className="mystical-button">
                Create Your Veilkin
              </a>
            </div>
          </div>

          {/* Features Preview */}
          <div className="grid md:grid-cols-3 gap-6 mt-12">
            <div className="mystical-card">
              <h3 className="mystical-subtitle mb-4">Magical Upgrades</h3>
              <p className="mystical-text">
                Unlock incredible upgrades for your Veilkin as you progress through your journey.
              </p>
            </div>
            <div className="mystical-card">
              <h3 className="mystical-subtitle mb-4">Chip System</h3>
              <p className="mystical-text">
                Track your progress with our unique chip system that rewards your artistic creations.
              </p>
            </div>
            <div className="mystical-card">
              <h3 className="mystical-subtitle mb-4">Community</h3>
              <p className="mystical-text">
                Join a vibrant community of artists and storytellers in this magical world.
              </p>
            </div>
          </div>
        </div>
      </main>

      {/* Mystical Footer */}
      <footer className="mystical-nav py-6 mt-auto">
        <div className="container mx-auto px-4 text-center">
          <p className="mystical-text font-bold">
            © 2025 4fingerstudios <br /> 
            © 2024 Reckless Dreams. All Rights Reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Home;